module.exports = __webpack_public_path__ + "img/nvidia-sign.55516b61.png";